var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.5C21 17.1944 17.1944 21 12.5 21C11.4232 21 10.3932 20.7998 9.44516 20.4345C9.27182 20.3678 9.18515 20.3344 9.11623 20.3185C9.04844 20.3029 8.99937 20.2963 8.92986 20.2937C8.85918 20.291 8.78164 20.299 8.62656 20.315L3.50554 20.8444C3.0173 20.8948 2.77318 20.9201 2.62917 20.8322C2.50375 20.7557 2.41832 20.6279 2.39558 20.4828C2.36947 20.3161 2.48613 20.1002 2.71944 19.6684L4.35509 16.6408C4.4898 16.3915 4.55715 16.2668 4.58765 16.147C4.61778 16.0286 4.62506 15.9432 4.61543 15.8214C4.60567 15.6981 4.55157 15.5376 4.44337 15.2166C4.15585 14.3636 4 13.45 4 12.5C4 7.80558 7.80558 4 12.5 4C17.1944 4 21 7.80558 21 12.5Z",
    stroke: "#137A84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9523 10.9413C11.2307 11.5211 11.6102 12.0646 12.0908 12.5452C12.5714 13.0259 13.1149 13.4054 13.6947 13.6838C13.8789 13.7722 14.0968 13.7268 14.2412 13.5824C14.6368 13.1869 15.278 13.1869 15.6735 13.5824L15.7515 13.6603C16.1901 14.0989 16.1901 14.8099 15.7515 15.2485L15.6884 15.3116C15.2775 15.7225 14.6906 15.9261 14.1315 15.7674C12.9182 15.423 11.7732 14.7732 10.818 13.818C9.86283 12.8628 9.21304 11.7179 8.86865 10.5045C8.70996 9.94541 8.91351 9.35857 9.32447 8.9476L9.38753 8.88455C9.82609 8.44598 10.5372 8.44598 10.9757 8.88455L11.0537 8.9625C11.4492 9.35802 11.4492 9.99928 11.0537 10.3948C10.9092 10.5392 10.8639 10.7572 10.9523 10.9413Z",
    fill: "#137A84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappOutline);
export default __webpack_public_path__ + "3a484ef7b6525963d91170551e965693.svg";
export { ForwardRef as ReactComponent };